module.exports = __webpack_public_path__ + "static/icon-2318f7fdc967e2836c67ac35f86a0834.png";